import { useAtom } from 'jotai'
import { CuiButton } from 'front-lib'
import { eaterProfileOnboardingModalAtom } from 'src/atoms/modals/eaterProfileOnboardingModal.atom'
import { track } from 'src/shared/tracking'
import './EaterProfileOnboardingModal.scss'

import aarthiSampath from 'src/assets/img/chefs/aarthi-sampath.jpg'
import jordanAndino from 'src/assets/img/chefs/jordan-andino.jpg'
import emilyPeck from 'src/assets/img/chefs/emily-peck.jpg'
import pierreThiam from 'src/assets/img/chefs/pierre-thiam.jpg'
import lenaElkousy from 'src/assets/img/chefs/lena-elkousy.jpg'
import andresMendez from 'src/assets/img/chefs/andres-mendez.jpg'
import akhtarNawab from 'src/assets/img/chefs/akhtar-nawab.jpg'
import { ResponsiveModalOrBottomSheet } from 'src/components/ResponsiveModalOrBottomSheet/ResponsiveModalOrBottomSheet'
import { useSelector } from 'react-redux'
import { getNextMenuUpcomingDay } from 'src/modules/MyPlan/selectors'
import { useHistory } from 'react-router-dom'

const chefImages: { [key: string]: string } = {
  'Aarthi Sampath': aarthiSampath,
  'Jordan Andino': jordanAndino,
  'Emily Peck': emilyPeck,
  'Pierre Thiam': pierreThiam,
  'Lena Elkousy': lenaElkousy,
  'Andres Mendez': andresMendez,
  'Akhtar Nawab': akhtarNawab
}

const chefs = [
  'Aarthi Sampath',
  'Jordan Andino',
  'Emily Peck',
  'Pierre Thiam',
  'Lena Elkousy',
  'Andres Mendez',
  'Akhtar Nawab'
]

export const EaterProfileOnboardingModal = () => {
  const [{ isOpen }, setModal] = useAtom(eaterProfileOnboardingModalAtom)
  const history = useHistory()
  const nextMenu = useSelector(getNextMenuUpcomingDay)

  const handleClose = () => {
    trackOverlayClicked('Close')
    setModal({ isOpen: false })
  }

  const handleContinue = () => {
    trackOverlayClicked('Continue')
    setModal({ isOpen: false })

    if (nextMenu?.date) {
      history.push(`/meals/?date=${nextMenu.date}`)
    }
  }

  const trackOverlayClicked = (action: string) => {
    track('Overlay Clicked', {
      overlay_name: 'Eater Profile Onboarding',
      overlay_action: action,
      overlay_class: 'modal',
      overlay_source: 'custom',
      overlay_type: 'Custom',
      page_name: 'Preferences',
      overlay_trigger: 'automatic'
    })
  }

  return (
    <ResponsiveModalOrBottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      className="eater-profile-onboarding-modal">
      <div className="eater-profile-onboarding-modal__content">
        <h2 className="title">Meet your culinary dream team</h2>
        <p className="description">
          Your preferences are set, and we’ve lined up the chefs whose menus
          best match your taste. Go ahead—explore crave-worthy meals tailored to
          you and discover new favorites!
        </p>
        <div className="chefs-grid">
          <div className="first-row">
            {chefs.slice(0, 4).map(chefName => (
              <div key={chefName} className="chef-card">
                <img
                  src={chefImages[chefName]}
                  alt={chefName}
                  className="chef-image"
                />
                <p className="chef-name">{chefName}</p>
              </div>
            ))}
          </div>
          <div className="second-row">
            {chefs.slice(4, 7).map(chefName => (
              <div key={chefName} className="chef-card">
                <img
                  src={chefImages[chefName]}
                  alt={chefName}
                  className="chef-image"
                />
                <p className="chef-name">{chefName}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="action_container">
          <CuiButton size="large" onClick={handleContinue}>
            Browse my matches
          </CuiButton>
        </div>
      </div>
    </ResponsiveModalOrBottomSheet>
  )
}
